import { UserProfile } from 'fitbeat.gym-core';
import { ICreatePlatformUser, KnownMediums, KnownSources } from 'fitbeat.models';
import { Platform } from 'react-native';
import { usesMetricSystem } from 'react-native-localize';
import { createUserServiceClient } from '../../utils/apiClientFactory';
import { addLegalAgreements } from './utils';

interface INewUserData {
  uid: string;
  email: string;
  firstname: string;
  lastname: string;
}

interface ISignupDeepLinkParams {
  planId?: string;
  workoutInviteId?: string;
  invitationCode?: string;
  coupon?: string;
  utm_medium?: KnownMediums | string;
  utm_source?: string;
  utm_campaign?: string;
  gymName?: string;
}

interface ICreateUserOptions {
  shouldAddLegalAgreements: boolean;
}

export function buildSignupSource(signUpDeepLinkParams) {
  const {
    utm_medium,
    utm_source,
    utm_campaign,
  } = signUpDeepLinkParams;
  if (utm_medium && utm_source) {
    return {
      medium: utm_medium,
      source: utm_source,
      campaign: utm_campaign,
    };
  }

  return  Platform.select({
    android: {
      medium: KnownMediums.appstore,
      source: KnownSources.googleplay,
    },
    ios: {
      medium: KnownMediums.appstore,
      source: KnownSources.appleappstore,
    },
    default: {
      medium: KnownMediums.webapp,
      source: KnownSources.fitillioncom,
    },
  });
}

export async function createPlatformUser(
  newUserData: INewUserData,
  signUpDeepLinkParams: ISignupDeepLinkParams,
  options: ICreateUserOptions,
): Promise<UserProfile> {

  const {
    planId,
    workoutInviteId,
    invitationCode,
    coupon,
    gymName,
  } = signUpDeepLinkParams;

  const signupSource = buildSignupSource(signUpDeepLinkParams);
  const createUserData: ICreatePlatformUser = {
    uid: newUserData.uid,
    email: newUserData.email,
    firstname: newUserData.firstname,
    lastname: newUserData.lastname,
    currentPlanId: planId,
    signupWorkoutInviteId: workoutInviteId,
    useImperialUnit: !usesMetricSystem(),
    invitationCode,
    coupon,
    signupSource,
    gymName,
  };

  if (UserProfile.signedUpThroughInfluencerLink(new UserProfile(createUserData.uid, createUserData))) {
    // TODO: pull account status from remote config
    createUserData.signupAccountStatus = 'LiteSubscription';
  }

  if (options.shouldAddLegalAgreements) {
    addLegalAgreements(createUserData);
  }

  const usc = createUserServiceClient();
  const { userProfile } = await usc.createUser(createUserData);
  return userProfile;
}
